export default __webpack_public_path__ + "static/media/laptop-graph-left3-small-380x380.c5db3630.png";